
function LinksComponent() {
    return (
        <div className="d-flex mt-2 ">
            <a className="m-2 text-light text-decoration-none" href="https://www.gnu.org/licenses/agpl-3.0.en.html" target="__blank" rel="noreferrer">License</a>
            <a className="m-2 text-light text-decoration-none" href="https://github.com/Jesus-Medina/Proyecto-Final-Vegan-Marketplace" target="__blank" rel="noreferrer">Source</a>
            <a className="m-2 text-light text-decoration-none" href="https://image.shutterstock.com/image-photo/security-guard-sleeping-surveillance-room-600w-1235203822.jpg" target="__blank" rel="noreferrer">Security</a>
            <a className="m-2 text-success text-decoration-none" href="https://www.linkedin.com/in/jesus-medina-gajardo/" target="__blank" rel="noreferrer">Contact us</a>
        </div>
    )
}

export default LinksComponent